import React, { useRef, useState } from 'react';
import { Button, Popup, PopupActionList, PopupSection } from '@ui';
import { t, tGeneric } from './translate';
function RowActions({ canRemove, onEdit, onRemove }) {
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);
    const label = t('row_actions');
    const choose = (action) => () => {
        setOpen(false);
        action();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { ref: anchorRef, "aria-haspopup": "menu", "aria-expanded": open, "aria-label": label, title: label, onClick: () => setOpen((prev) => !prev) },
            React.createElement("i", { className: "fa-light fa-ellipsis", "aria-hidden": "true" })),
        React.createElement(Popup, { anchor: anchorRef.current, show: open, onClose: () => setOpen(false), position: "bottom-right" },
            React.createElement(PopupSection, null,
                React.createElement(PopupActionList, null,
                    React.createElement(Button, { role: "menuitem", className: "qmb-ui-popup__action", onClick: choose(onEdit) }, tGeneric('edit')),
                    canRemove && (React.createElement(Button, { role: "menuitem", className: "qmb-ui-popup__action", onClick: choose(onRemove) }, tGeneric('remove'))))))));
}
export default RowActions;
